import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {decrypt, encrypt} from "./Encriptacion";

const CompanyRouter: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    const encryptedData = sessionStorage.getItem('dataClient');

    useEffect(() => {
        const companyFromURL = location.pathname.split('/')[1]; // Extract company name from URL

        if (!encryptedData) {
            navigate(`/${companyFromURL}`, { replace: true });
            return;
        }

        try {
            const data = decrypt(encryptedData, CLAVE);
            const companyFromSession = JSON.parse(data).initials;

            if (companyFromSession !== companyFromURL) {
                sessionStorage.clear();
                sessionStorage.setItem("auth", encrypt("false", CLAVE));
                navigate(`/${companyFromURL}`, { replace: true });
            }
        } catch (error) {
            console.error("Error decrypting data:", error);
            sessionStorage.clear();
            sessionStorage.setItem("auth", encrypt("false", CLAVE));
            navigate(`/${companyFromURL}`, { replace: true });
        }
    }, [location, navigate, encryptedData, CLAVE]);

    return null;
}

export default CompanyRouter;
